import { Capacitor } from '@capacitor/core'

/** PWA standalone або Capacitor — не генерувати звіти з телефону. */
export function isAppShell(): boolean {
  if (typeof window === 'undefined') return false
  if (Capacitor.isNativePlatform()) return true
  const nav = window.navigator as Navigator & { standalone?: boolean }
  if (nav.standalone) return true
  return window.matchMedia('(display-mode: standalone)').matches
}
